import { call, put, takeLatest, select } from 'redux-saga/effects';
import {
  DELETE_NOTE_SUCCESS,
  DELETE_NOTE_REQUEST,
  DELETE_NOTE_FAILURE,
  AUTO_SAVE_NOTE_SUCCESS,
  AUTO_SAVE_NOTE_FAILURE,
  AUTO_SAVE_NOTE_REQUEST,
} from './actions';
import { push } from 'connected-react-router';
import { tokenSelector } from '../Main/reducer';
import { del, post } from '../../utils/api';
import { toast } from 'react-toastify';
import { handleApiError } from '../../utils/handleApiError';

function* autoSaveNote({ payload }) {
  try {
    const token = yield select(tokenSelector);
    const response = yield call(
      post,
      `/notes/create-or-update`,
      { noteId: payload.id, title: payload.title, text: payload.text },
      token
    );

    const note = response.data.note;

    yield put({
      type: AUTO_SAVE_NOTE_SUCCESS,
      payload: {
        id: note.id,
        text: note.text,
        title: note.title,
        date: note.updated_date,
      },
    });
    toast.info(`Note ${payload.title} auto saved!`);
  } catch (error) {
    yield handleApiError(error, AUTO_SAVE_NOTE_FAILURE);
  }
}

function* deleteNote({ payload }) {
  const ids = { noteIds: [payload] };
  try {
    const token = yield select(tokenSelector);
    yield call(del, `/notes/delete`, token, ids);
    yield put({ type: DELETE_NOTE_SUCCESS, payload });
    yield put(push('/'));
    toast.info(`Note Deleted!`);
  } catch (error) {
    yield handleApiError(error, DELETE_NOTE_FAILURE);
  }
}

export default [
  takeLatest(DELETE_NOTE_REQUEST, deleteNote),
  takeLatest(AUTO_SAVE_NOTE_REQUEST, autoSaveNote),
];
